import React from 'react';
import { arrayOf, string, func, node } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import IndustryPicker from '../../../IndustryPicker';
import DropdownFilterWrapper from '../DropdownFilterWrapper';
import { useIndustriesDropdownState } from './hooks/useIndustriesDropdownState';
import classes from './index.module.scss';

const DefaultTitle = () => (
    <>
        <I18n k="variations_display.marketplace_listing.brief.placeholder.industries" />
        <span className={classes.secondaryTitle}>
            <I18n k="variations_display.marketplace.modal.make_your_logo.industry_input.restriction" />
        </span>
    </>
);

export const IndustriesDropdown = ({
    industries: propIndustries,
    handleApply,
    applyButtonColor,
    title = <DefaultTitle />,
    placeholder,
}) => {
    const { canApply, canClear, industries, setIndustries, handleClear } =
        useIndustriesDropdownState(propIndustries);

    return (
        <DropdownFilterWrapper
            className={classes.wrapper}
            applyButtonColor={applyButtonColor}
            title={title}
            canClear={canClear}
            canApply={canApply}
            onClear={handleClear}
            onApply={() => handleApply(industries)}
        >
            <IndustryPicker
                values={industries}
                className={classes.industryPicker}
                onChange={setIndustries}
                placeholder={placeholder}
            />
        </DropdownFilterWrapper>
    );
};

IndustriesDropdown.propTypes = {
    handleApply: func,
    industries: arrayOf(string),
    applyButtonColor: string,
    title: node,
    placeholder: string,
};
